export default "__VITE_PUBLIC_ASSET__0b5746c2__"